<template>
   <div class="home-presentation">
        <div class="type_reseau">
            <i :class="iconNetwork[Network]"></i>
            {{ Network }}
        </div>
        <img class="picture" :src="PictureUrl">
        <h3>{{ $t('dash.reporting.pdf.slideHome.rapport') }} {{ Network }}</h3>
        <h4>{{ PageName }}</h4>
        <p>{{ DateStart.toLocaleString('fr-FR',{year: 'numeric', month: 'long', day: 'numeric'}) }} - {{ DateEnd.toLocaleString('fr-FR',{year: 'numeric', month: 'long', day: 'numeric'}) }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            Network: String,
            PageName: String,
            DateStart: Date,
            DateEnd: Date,
            PictureUrl: String
        },

        data() {
            return {
                iconNetwork : {
                    instagram : "fa-brands fa-instagram",
                    facebook : "fa-brands fa-facebook",
                    linkedin : "fa-brands fa-linkedin-in"
                }
            }
        },
    }
</script>
